export default {
    install: function (Vue, options) {
        let tags = 'util_v_0.0.1';
        Vue.prototype.InitUtil = function () {
            console.log(tags, 'InitUtil', options);
        }

        Vue.prototype.isLog = process.env.VUE_APP_LOG === 'log';

        //时间格式化
        Vue.prototype.FormatTime = function (time, fmt) {
            let h = Math.floor(time / (60 * 60));
            let hRemain = time % (60 * 60);
            let m = Math.floor(hRemain / 60);
            let s = hRemain % 60;

            let obj = {
                "h+": ('00' + h).substr(-2),
                "m+": ('00' + m).substr(-2),
                "s+": ('00' + s).substr(-2),
            }
            for (let key in obj) {
                let pat = `(${key})`
                if (new RegExp(pat).test(fmt)) {
                    let str = obj[key] + '';
                    // RegExp.$1 hh mm ss贪婪匹配
                    fmt = fmt.replace(RegExp.$1, str)
                }
            }
            return fmt;
        }

        Vue.prototype.curTime = function (){
            return parseInt(new Date().getTime()/1000);
        }

        Vue.prototype.jsonToStr = function (json){
            if(typeof json === 'object'){
                return JSON && JSON.stringify(json);
            }
        }

        Vue.prototype.strToJson = function(str){
            if(typeof str === 'string'){
                return JSON && JSON.parse(str);
            }
        };

        Vue.prototype.dom = function(el, selector){
            if(arguments.length === 1 && typeof arguments[0] == 'string'){
                if(document.querySelector){
                    return document.querySelector(arguments[0]);
                }
            }else if(arguments.length === 2){
                if(el.querySelector){
                    return el.querySelector(selector);
                }
            }
        };

        Vue.prototype.domAll = function(el, selector){
            if(arguments.length === 1 && typeof arguments[0] == 'string'){
                if(document.querySelectorAll){
                    return document.querySelectorAll(arguments[0]);
                }
            }else if(arguments.length === 2){
                if(el.querySelectorAll){
                    return el.querySelectorAll(selector);
                }
            }
        };
    }
}

